import React from 'react';
import Header from '../components/Header';
import PlansSection from '../components/PlansSection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const PlanesPage = () => {
  const seoData = {
    title: 'Planes y Precios',
    description: 'Planes de automatización de atención al cliente y desarrollos de software a medida. Plan Pro desde $60 USD/mes, Plan Full con asesoría desde $450 USD/mes, y herramientas empresariales con Tienda Runa.',
    keywords: 'planes runamatic, precios automatización, plan pro, plan full, desarrollos a medida, tienda runa, chatbot precios, WhatsApp Business, sistemas de gestión',
    canonical: '/planes',
    ogTitle: 'Planes y Precios - Runamatic',
    ogDescription: 'Automatización de atención al cliente y desarrollos a medida. Plan Pro desde $60 USD/mes. Plan Full desde $450 USD/mes. Herramientas en Tienda Runa.',
    schema: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Planes y Servicios Runamatic",
      "description": "Automatización de atención al cliente, desarrollos de software a medida y herramientas empresariales",
      "provider": {
        "@type": "Organization",
        "name": "Runamatic",
        "url": "https://runamatic.io"
      },
      "offers": [
        {
          "@type": "Offer",
          "name": "Plan Pro",
          "price": "60",
          "priceCurrency": "USD",
          "description": "Todas las herramientas de la plataforma con IA incluida. Modalidad auto gestión."
        },
        {
          "@type": "Offer",
          "name": "Plan Full",
          "price": "450",
          "priceCurrency": "USD",
          "description": "Asesoría completa de estrategia comercial + configuración 100% personalizada por nuestro equipo"
        }
      ]
    }
  };

  return (
    <>
      <SEO {...seoData} />
      <Header />
      <main>
        <PlansSection />
      </main>
      <Footer />
    </>
  );
};

export default PlanesPage;
